import { render } from "./KapibaraFooter.vue?vue&type=template&id=c8ba01ea"
import script from "./KapibaraFooter.vue?vue&type=script&lang=js"
export * from "./KapibaraFooter.vue?vue&type=script&lang=js"

import "./KapibaraFooter.vue?vue&type=style&index=0&id=c8ba01ea&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__